import {
  Action,
  createReducer,
  on,
  createFeatureSelector,
  createSelector
} from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import {
  ProfileInfo,
  loadProfileInfo,
  loadProfileInfoById,
  loadProfileInfoSuccess,
  loadProfileReferencesSuccess,
  addReferenceSuccess
} from './info.actions';
import {
  addContactSuccess,
  removeContactSuccess
} from 'src/app/core/services/contacts/contacts.actions';

export const profileKey = 'profileInfo';

export interface ProfileState extends EntityState<ProfileInfo> {
  // additional entities state properties
  profileInfo: any;
  references: any[];
}

export const adapter: EntityAdapter<ProfileInfo> =
  createEntityAdapter<ProfileInfo>();

export const initialState: ProfileState = adapter.getInitialState({
  // additional entity state properties
  profileInfo: null,
  references: [],
  error: null
});

export const profileReducer = createReducer(
  initialState,
  on(loadProfileInfo, (state, action) => ({ ...state, profileInfo: null })),
  on(loadProfileInfoById, (state, action) => ({ ...state, profileInfo: null })),
  on(loadProfileInfoSuccess, (state, action) => ({
    ...state,
    profileInfo: action.profileInfo
  })),
  on(addContactSuccess, (state, action) => {
    if (!state.profileInfo || state.profileInfo.id !== action.id) {
      return state;
    }

    return {
      ...state,
      profileInfo: {
        ...state.profileInfo,
        friend_request: true
      }
    };
  }),
  on(removeContactSuccess, (state, action) => {
    if (!state.profileInfo || state.profileInfo.id !== action.id) {
      return state;
    }

    return {
      ...state,
      profileInfo: {
        ...state.profileInfo,
        friend_request: false,
        is_friend: false
      }
    };
  }),
  on(loadProfileReferencesSuccess, (state, action) => {
    return {
      ...state,
      references: action.references
    };
  }),
  on(addReferenceSuccess, (state, action) => {
    return {
      ...state,
      references: [action.reference, ...state.references]
    };
  })
);

export const selectState = createFeatureSelector<ProfileState>(profileKey);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors(selectState);

export const selectProfileInfo = (state: ProfileState) =>
  state.profileInfo.profileInfo;
export const selectProfileId = (state: ProfileState) =>
  state.profileInfo.profileInfo.id;

export const selectProfileReferences = () =>
  createSelector(selectState, (state: ProfileState) => {
    return state.references;
  });
